export const CAREER_PLAN_ANALYTICS_EVENTS = {
  hubViewed: "m360_career_plan_hub_viewed"
} as const;
